import React from 'react';
import { Grid, Skeleton, styled, Box } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { CircularSkeleton } from '../ClientTable/LoadingSkeleton';

const RoundedSkeleton = styled(Skeleton)(({ width, height }) => ({
  animation: 'wave',
  width,
  height,
  background: 'linear-gradient(270deg, rgba(219, 219, 219, 0.05) 0%, #DBDBDB 50%)',
  borderRadius: '10px',
}));

const NotesLoading = () => (
  <Grid height="max-height" display="flex" flexDirection="column">
    <Grid gap="4px" display="flex" flexDirection="row">
      <CircularSkeleton variant="circular" width={24} height={24} />
      <Box>
        {[...Array(7)].map((_count) => (
          <img key={uuidv4()} src="/assets/icons/tab-loading.svg" alt="tab-loading" />
        ))}
      </Box>
      <RoundedSkeleton variant="rounded" width={84} height={14} sx={{ mt: '5px' }} />
    </Grid>
    <Grid>
      <RoundedSkeleton variant="rounded" width={750} height={500} />
    </Grid>
  </Grid>
);

export default NotesLoading;
